import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { blogService } from '../../services/blogService';

export const useGetBlogArticleDetail = slug => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    queryKey: [QUERY_KEYS.blog.article_detail, slug],
    queryFn: () =>
      blogService.article(slug).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
